/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxSedonaGrillComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withAlias('LynxSedonaGrill').attach(memoEval((self)=>[
            self.$grillObjectName
        ], ($grillObjectName)=>({
            fileUrl: '/models/jms.glb',
            objectName: $grillObjectName,
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-sedona-grill.js.map